import { FC } from 'react';
interface IFavorites {
  active?: boolean;
}
const Favorites: FC<IFavorites> = ({ active }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={active ? '#7B6A60' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.166 3.75H16.167C18.9983 3.75017 21.25 5.91963 21.25 8.54395C21.25 10.8372 19.9814 13.0086 18.3994 14.8613L18.0791 15.2275C16.5546 16.9302 14.7237 18.431 13.2051 19.5879L12.5752 20.0625C12.4144 20.1821 12.212 20.25 12 20.25C11.841 20.25 11.6874 20.2121 11.5527 20.1426L11.4248 20.0625C9.90684 18.9313 7.9285 17.3818 6.25 15.5889L5.91895 15.2275C4.19308 13.2975 2.75 10.99 2.75 8.54395C2.75004 5.91963 5.0017 3.75017 7.83301 3.75C9.26231 3.75 10.5548 4.3086 11.4785 5.20215L12.001 5.70801L12.5225 5.20215C12.9955 4.74351 13.5607 4.37781 14.1865 4.12793C14.7343 3.90923 15.3181 3.78322 15.9111 3.75586L16.166 3.75Z"
        stroke="#7B6A60"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Favorites;
